import React from 'react';
import {getDate, getMessageText, useStyles} from './helper';
import {useRouter} from '../../../../../@casino/useRouter';

const SupportItem = ({item, view}) => {
    const {label_name, message, data, status, id} = item;
    
    const classes = useStyles();
    const router = useRouter();

    return (
        <div className={classes.root} onClick={() => {
            if (!view) {
                router.history.push(`/support/view/${id}`)
            }
        }}>
            <span className={classes.date}>{getDate(data)}</span>
            {
                status && !view &&
                <span className={classes.read}>!</span>
            }
            <span>{label_name}</span>
                
            <span className={classes.message}>{getMessageText(message, view)}</span>
        </div>
    )
}

export default SupportItem;